import { Injectable } from "@angular/core";
import { MatDateFormats, NativeDateAdapter } from "@angular/material/core";

// Custom Date Adapter to handle DD/MM/YYYY date format
@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
    override parse(value: any): Date | null {
        if (typeof value === 'string' && value.length === 10) {
            const [day, month, year] = value.split('/');
            const parsedDate = new Date(+year, +month - 1, +day);
            return isNaN(parsedDate.getTime()) ? null : parsedDate;
        }
        return super.parse(value);
    }

    override format(date: Date, displayFormat: string): string {
        if (!date) {
            return '';
        }
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }
}

export const MY_DATE_FORMATS: MatDateFormats = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMMM YYYY',
        dateA11yLabel: 'DD/MM/YYYY',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};